import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import { LoginPage } from "../auth/pages";
import { PrivateRoutes } from "./PrivateRoutes";
import { isLogin } from "../helpers/auth";

export const AppRouter = () => {
  const [isLogged, setIsLogged] = useState(false);
  const [validando, setValidando] = useState(true);
  const location = useLocation(); // Hook para obtener la URL actual

  const verifyToken = async () => {
    const status = await isLogin();
    setIsLogged(status);
    setValidando(false);
    if (status === false) {
      localStorage.removeItem("token");
    }
  };

  useEffect(() => {
    setValidando(true);
    verifyToken();
  }, [location.pathname]);

  if (validando) {
    return;
  }

  return (
    <Routes>
      <Route path="login" element={<LoginPage isLogged={isLogged} />} />
      <Route path="/*" element={<PrivateRoutes isLogged={isLogged} />} />
    </Routes>
  );
};
